// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Moeda do anúncio",
  change: "Alterar",
  mismatchDot: "As moedas deste anúncio não coincidem",
  channexText: "Este anúncio está ligado ao Channex. Lá a moeda de uma tarifa não pode ser alterada: é preciso recriá-la. Escreva-nos e tratamos disso sem interromper as suas vendas nas OTAs.",
  channexOnly: "Está ligado ao Channex: só pode usar {currency}, a moeda das suas tarifas lá.",
  modal: {
    title: "Moeda do anúncio",
    lead: "É a moeda em que cobra aos hóspedes deste anúncio.",
    scope: "Muda ao mesmo tempo no anúncio, em todos os seus alojamentos e nas suas tarifas. Os links de pagamento, o agente de IA e o check-out tardio usarão esta moeda.",
    label: "Moeda",
    mismatch: "Neste momento não coincidem: o anúncio diz {listing} e os seus alojamentos cobram em {units}. Ao guardar, fica tudo na mesma.",
    channexTitle: "Não é possível alterar aqui",
    cancel: "Cancelar",
    close: "Entendido",
    save: "Guardar",
    saving: "A guardar…",
    saved: "Moeda do anúncio atualizada para {currency}.",
    error: "Não foi possível alterar a moeda. Tente novamente.",
  },
  sugerencia: {
    titleCountry: "Este anúncio cobra em {current}",
    textCountry: "Em {country} costuma pagar-se em {suggested}. Se a alterar, os links de pagamento, o agente de IA e o check-out tardio usarão {suggested}.",
    titleMismatch: "As moedas deste anúncio não coincidem",
    textMismatch: "O anúncio diz {listing} e os seus alojamentos cobram em {units}. Deixe só uma para que o que a IA anuncia e o que se cobra seja o mesmo.",
    useSuggested: "Mudar para {currency}",
    other: "Escolher outra",
    keep: "Manter {currency}",
  },
};
